import { TopPartner } from "../../../api/payments/overview/overview.responses";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../ui/Table";

interface TopPartnersCardProps {
  topPartners: TopPartner[];
}

export function TopPartnersCard({ topPartners }: TopPartnersCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Top Partners</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {topPartners.length === 0 ? (
          <p className="px-6 pb-4 text-sm text-muted-foreground">
            No partners yet.
          </p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Partner</TableHead>
                <TableHead className="text-right">Codes</TableHead>
                <TableHead className="text-right">Redemptions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {topPartners.map((p) => (
                <TableRow key={p.id}>
                  <TableCell className="font-medium">{p.name}</TableCell>
                  <TableCell className="text-right">{p.promoCodeCount}</TableCell>
                  <TableCell className="text-right">
                    {p.completedRedemptions}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
